module.exports = __webpack_public_path__ + "static/iphone-events-fcd1c64f596d73b4bfa30953a337e220.png";